import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SmartRedirect = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const getRedirectPath = () => {
            if (location.state?.from?.pathname) {
                const pathname = location.state.from.pathname;
                const search = location.state.from.search || '';
                const hash = location.state.from.hash || '';
                return `${pathname}${search}${hash}`;
            }

            return '/dashboard';
        };
        
        const path = getRedirectPath();
        navigate(path, { replace: true });
    }, [navigate, location.state]);

    return null;
};

export default SmartRedirect;